import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function withAdmin(password) {
  return { headers: { "X-Admin-Password": password } };
}

export function levelInfo(level) {
  const titles = ["Rookie", "Rhythm Scholar", "Beat Master", "Word & Drum Maestro", "Legendary Rockstar"];
  return titles[level - 1] || "Rockstar";
}
